import { Link } from "react-router-dom";
import BackToTop from "@/components/feature/BackToTop";
import Breadcrumbs from "@/components/feature/Breadcrumbs";
import FaqAccordion from "@/components/feature/FaqAccordion";
import Reveal from "@/components/feature/Reveal";
import Seo from "@/components/feature/Seo";
import SiteFooter from "@/components/feature/SiteFooter";
import SiteHeader from "@/components/feature/SiteHeader";
import useHashScroll from "@/hooks/useHashScroll";
import { faqs } from "@/mocks/faqs";
import { contactEmail } from "@/mocks/site";

export default function FaqPage() {
  useHashScroll();

  return (
    <div className="flex min-h-screen w-full flex-col bg-background-50">
      <Seo
        title="常见问题 - 内容来源·准确性·更新方式 | 15黑料网"
        description="关于15黑料网的内容来源、准确性、更新方式与投稿线索等常见问题解答，帮助你在阅读前先了解我们的工作方式。"
        keywords="15黑料网常见问题,内容来源,准确性说明,投稿线索"
        canonicalPath="/faq"
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faqs.map((item) => ({
              "@type": "Question",
              name: item.question,
              acceptedAnswer: { "@type": "Answer", text: item.answer },
            })),
          },
          {
            "@context": "https://schema.org",
            "@type": "BreadcrumbList",
            itemListElement: [
              { "@type": "ListItem", position: 1, name: "首页", item: "https://sznita.cn/" },
              { "@type": "ListItem", position: 2, name: "常见问题", item: "https://sznita.cn/faq" },
            ],
          },
        ]}
      />
      <SiteHeader />
      <main className="w-full flex-1">
        <section className="w-full border-b border-background-200 bg-background-100/60">
          <div className="mx-auto w-full max-w-[1400px] px-4 pb-10 pt-8 md:px-8 md:pb-12 md:pt-10">
            <Breadcrumbs items={[{ label: "常见问题" }]} />
            <h1 className="mt-5 font-heading text-3xl font-black text-foreground-950 md:text-4xl">
              常见问题
            </h1>
            <p className="mt-4 max-w-3xl text-sm leading-relaxed text-foreground-600 md:text-base">
              在开始阅读之前，你可能想先知道我们是怎么选事件、怎么写、怎么处理不确定信息的。下面这些问题覆盖了最常见的
              疑问，如果没有你想要的答案，欢迎直接联系编辑部。
            </p>
          </div>
        </section>

        <section aria-label="常见问题列表" className="w-full bg-background-50">
          <div className="mx-auto grid w-full max-w-[1400px] grid-cols-1 gap-10 px-4 py-12 md:px-8 md:py-14 lg:grid-cols-12">
            <div className="lg:col-span-8">
              <Reveal>
                <FaqAccordion items={faqs} defaultOpen={-1} />
              </Reveal>
            </div>
            <aside className="lg:col-span-4">
              <div className="lg:sticky lg:top-24 space-y-6">
                <div className="rounded-lg border border-background-200 bg-secondary-50 p-6">
                  <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-500 text-background-50">
                    <i className="ri-question-answer-line text-xl" aria-hidden="true" />
                  </span>
                  <h2 className="mt-5 font-heading text-lg font-black text-foreground-950">
                    还有别的问题？
                  </h2>
                  <p className="mt-3 text-sm leading-relaxed text-foreground-600">
                    你可以在「关于我们」页留言，或直接发邮件。涉及线索的来信我们会优先处理。
                  </p>
                  <Link
                    to="/about#contact"
                    className="mt-5 inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
                  >
                    前往留言
                    <i className="ri-arrow-right-line" aria-hidden="true" />
                  </Link>
                </div>
                <div className="rounded-lg border border-background-200 bg-background-100/60 p-6">
                  <p className="label-caps text-[11px] text-foreground-500">Contact</p>
                  <a
                    href={`mailto:${contactEmail}`}
                    className="mt-3 block font-heading text-base font-bold text-foreground-950 transition-colors hover:text-primary-600 cursor-pointer"
                  >
                    {contactEmail}
                  </a>
                  <p className="mt-3 text-xs leading-relaxed text-foreground-500">
                    工作日通常会在 48 小时内回复。请尽量在来信中附上可核验的公开链接或原始材料。
                  </p>
                </div>
              </div>
            </aside>
          </div>
        </section>
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}